/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteGithubAttachedObjectInput = {
    id?: string | null | undefined;
    taskId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteGithubAttachedObjectMutationVariables = {
    input: DeleteGithubAttachedObjectInput;
};
export type deleteGithubAttachedObjectMutationResponse = {
    readonly deleteGithubAttachedObject: {
        readonly deletedGithubAttachedObjectId: string | null;
    } | null;
};
export type deleteGithubAttachedObjectMutation = {
    readonly response: deleteGithubAttachedObjectMutationResponse;
    readonly variables: deleteGithubAttachedObjectMutationVariables;
};



/*
mutation deleteGithubAttachedObjectMutation(
  $input: DeleteGithubAttachedObjectInput!
) {
  deleteGithubAttachedObject(input: $input) {
    deletedGithubAttachedObjectId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteGithubAttachedObjectInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGithubAttachedObjectPayload",
    "kind": "LinkedField",
    "name": "deleteGithubAttachedObject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedGithubAttachedObjectId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteGithubAttachedObjectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteGithubAttachedObjectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteGithubAttachedObjectMutation",
    "operationKind": "mutation",
    "text": "mutation deleteGithubAttachedObjectMutation(\n  $input: DeleteGithubAttachedObjectInput!\n) {\n  deleteGithubAttachedObject(input: $input) {\n    deletedGithubAttachedObjectId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'da16d7aff68157b2b99e52ac46da8dae';
export default node;
